import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "store";

interface PreferredLanguageState {
    hasLoans: boolean;
}

const initialState: PreferredLanguageState = {
    hasLoans: false,
};

const preferredLanguageSlice = createSlice({
    name: "preferredLanguage",
    initialState,
    reducers: {
        setHasLoans(state, action: PayloadAction<boolean>) {
            state.hasLoans = action.payload;
        },
    },
});

export const { setHasLoans } = preferredLanguageSlice.actions;

export const selectHasLoans = (state: RootState) => state.preferredLanguage.hasLoans;

export default preferredLanguageSlice.reducer;
